<div nz-row>
  <label class="heading-modal">
    Your current level is {{ accesslbl }}. Select your new level below. If you
    have questions about the levels, please contact us at.
  </label>
  <a class="heading-modal" href="mailto:someone@example.com"
    >support@visiblealpha.com</a
  >
</div>

<div nz-row>
  <div *ngFor="let item of reportType; let i = index" nz-col [nzSpan]="8">
    <ng-container *ngIf="item.name == 'Prod'">
      <div class="access-box">
        <label nz-checkbox nzDisabled [ngModel]="true">Checkbox</label>
        <div class="access-box-container">
          <div class="access-type-row" nz-row>
            <div class="access-type-box selected" nz-col [nzSpan]="24">
              {{ i + 1 }}
            </div>
          </div>
          <div nz-row class="alien-center">
            <label class="font_11 line_height_1">
              {{ item.displayname }}
            </label>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="item.name == 'EA'">
      <div class="access-box">
        <label nz-checkbox nzDisabled [ngModel]="accessEA">Checkbox</label>
        <div class="access-box-container">
          <div class="access-type-row" nz-row>
            <div class="access-type-box selected" nz-col [nzSpan]="24">
              {{ i + 1 }}
            </div>
          </div>
          <div nz-row class="alien-center">
            <label class="font_11 line_height_1">
              {{ item.displayname }}
            </label>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="item.name == 'Labs & EA'">
      <div class="access-box">
        <label nz-checkbox [(ngModel)]="accessEAAndLabs">Checkbox</label>
        <div class="access-box-container">
          <div class="access-type-row" nz-row>
            <div
              class="access-type-box"
              [ngClass]="accessEAAndLabs ? 'selected' : 'unselected'"
              nz-col
              [nzSpan]="24"
            >
              {{ i + 1 }}
            </div>
          </div>
          <div nz-row class="alien-center">
            <label class="font_11 line_height_1">
              {{ item.displayname }}
            </label>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<div *nzModalFooter>
  <button nz-button nzType="default" (click)="destroyModal()">Cancel</button>
  <button nz-button nzType="primary" (click)="submitChange()">Change</button>
</div>
